import HcsButton from "./hcs-button";

export default class HcsButtonShoppingCart extends HcsButton {
    constructor(props) {
        super(props);
    }

    // override from base class
    buttonClick() {
        let self = this;

        const { hcs } = this.props;

        // Must disable button to avoid double-click events
        this.disable();

        hcs.cart.addToBasket({
            success: _ => {
                self.enable();
                super.triggerConfigurator();
            },
            error: _ => {
                self.enable();
            }
        });
    }

    // override from base class
    isVisible() {
        return true;
    }

    buttonText() {
        return `<svg icon-id=\"icn-040-2-cart\" version=\"2.0\">
                <use href=\"#icn-040-2-cart\"></use>
            </svg>` + super.buttonText();
    }

    buttonClasses() {
        let inputClasses = ["hcs-button", "hcs-secondary", "hcs-shoppingcart"];

        return inputClasses;
    }
}